import { ChevronRight } from "lucide-react";
import SideSubMenu from "./SideSubMenu";
import { memo } from "react";
import IconComponent from "./IconComponents";


const SideMenu = ({
  menuItems,
  activeItem,
  expandedItems,
  handleItemClick,
  botSubscriptions,
  isMobile,
  isSideBar,
  handleSubItemClick,
  acceptedContacts,
  allProfileImages,
  triggerStaticBotData,
  selectedBotDetails
}) => {

  return (
    <div className="flex-1 overflow-hidden">
      <nav className="h-full overflow-y-auto py-3 sm:py-4 overflow-x-hidden">
        <ul className="space-y-[10px]">
          {menuItems.map((item, index) => {

            const isActive = activeItem === item.name;
            const isExpanded = expandedItems?.has(item.name);
            
            return (
              <li key={item.name}>
                <button
                  onClick={() => item.name === "Home" ? triggerStaticBotData() : item.name === "Contacts" ? handleItemClick("Contacts") : item.name === "Messages" ? handleItemClick("Messages") : handleItemClick(item)}
                  className={`w-full flex items-center text-left transition-colors font-semibold duration-200 py-[7px] px-3 rounded-7 text-size-14 ${isActive
                    ? `${!isMobile && !isSideBar
                      ? "bg-purple-100 text-primary-blue"
                      : "bg-[#e7e7ff1f] filter brightness-0 invert"
                    }`
                    : `hover:!text-primary-blue filter brightness-0 invert hover:!filter-none hover:${!isMobile && !isSideBar
                      ? "bg-purple-100 !text-primary-blue"
                      : "bg-[#e7e7ff1f] hover:!filter hover:brightness-0 hover:invert"
                    }`
                    }`}
                >
                  <IconComponent icon={item.icon} />
                  {!isMobile && !isSideBar && (
                    <>
                      <span className="flex-1 truncate">{item.name}</span>
                      {botSubscriptions && (
                        <ChevronRight
                          className={`w-4 h-4 transition-transform duration-200 flex-shrink-0 ${isExpanded ? "rotate-90" : ""
                            } ${isActive
                              ? "text-primary-blue"
                              : "text-black opacity-40"
                            }`}
                        />
                      )}
                    </>
                  )}
                </button>

                {/* Submenu */}
                <SideSubMenu
                  botSubscriptions={botSubscriptions}
                  isExpanded={isExpanded}
                  activeItem={activeItem}
                  item={item}
                  handleSubItemClick={handleSubItemClick}
                  isMobile={isMobile}
                  isSideBar={isSideBar}
                  acceptedContacts={acceptedContacts}
                  allProfileImages={allProfileImages}
                  selectedBotDetails={selectedBotDetails}
                />
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  )
};

export default memo(SideMenu);